module.exports = __webpack_public_path__ + "static/img/sjzlpt2.c1589149.jpeg";